import { render, staticRenderFns } from "./GeneralWindow.vue?vue&type=template&id=3b3eeb6a&scoped=true"
import script from "./GeneralWindow.vue?vue&type=script&lang=js"
export * from "./GeneralWindow.vue?vue&type=script&lang=js"
import style0 from "./GeneralWindow.vue?vue&type=style&index=0&id=3b3eeb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3eeb6a",
  null
  
)

export default component.exports